import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Chip, Box, useMediaQuery } from "@mui/material";
import MDTypography from "ui/MDTypography";
import roleService from "services/role-service";
import { DetailRow } from "layouts/common/detail-page";
import { EditButton } from "layouts/common/buttons";
import { DetailPageLayout } from "examples/LayoutContainers/DetailPageLayout";
import { useTheme } from "@mui/material/styles";

const RoleDetail = () => {
  const { id } = useParams();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchRole = async () => {
      const response = await roleService.get(id);
      if (response.success) {
        setRole(response.role);
      }
      setLoading(false);
    };
    fetchRole();
  }, [id]);

  const renderRoleDetails = () => {
    if (!role) {
      return (
        <MDTypography variant="body2" color="error">
          Role Not Found
        </MDTypography>
      );
    }

    const { name, permissions } = role;

    return (
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="flex-start">
            {/* Role Name */}
            <Grid item xs={12} md={4}>
              <DetailRow label="Role Name" value={name} />
            </Grid>

            {/* Permissions - same line, professional look */}
            <Grid item xs={12} md={8}>
              <MDTypography
                variant="caption"
                fontWeight="bold"
                color="text"
                display="block"
                mb={0.5}
              >
                Permissions
              </MDTypography>
              {permissions && permissions.length > 0 ? (
                <Box
                  sx={{
                    display: isMobile ? "grid" : "flex",
                    flexWrap: isMobile ? "unset" : "wrap",
                    gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : "none",
                    gap: "8px",
                    borderRadius: "8px",
                    padding: "8px 10px",
                  
                  }}
                >
                  {permissions.map((perm, index) => (
                    <Chip
                      key={index}
                      label={perm
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                      variant="outlined"
                      size="small"
                      sx={{
                        fontSize: "0.8rem",
                      }}
                    />
                  ))}
                </Box>

              ) : (
                <MDTypography variant="body2" color="textSecondary">
                  No Permissions Assigned
                </MDTypography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const actionButtons = () => (
    <>
      <EditButton link={`/roles/${role?.id}/edit`} />
    </>
  );

  return (
    <DetailPageLayout
      title="Role Details"
      renderContent={renderRoleDetails}
      actionButtons={actionButtons}
      backButtonRoute="/roles"
      loading={loading}
    />
  );
};

export default RoleDetail;
